import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlanComponent } from './plan.component';
import { PlanEditComponent } from '../plan-edit/plan-edit.component';

const routes: Routes = [
  {
    path: '',
    component: PlanComponent,
    data: { title: 'Pläne' }
  },
  {
    path: 'new',
    component: PlanEditComponent,
    data: { title: 'Neuer Plan' }
  },
  {
    path: ':id',
    component: PlanEditComponent,
    data: { title: 'Plan Bearbeiten' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanRoutingModule { }




























